import React from 'react'
import PropTypes from 'prop-types'
import { DownloadIcon } from 'secondstep-components'
import { StyledLinkDropdown } from './component.styles'
import NavigationHelper from 'layers/navigation/navigationHelper'

// Handles navigation and download logic for dropdown links
const LinkDropdownNavigation = (link, navigationEvent) => {
  const { download = null, openSameTab, url: optionUrlPath } = link || {}

  if (download) {
    navigationEvent(download, NavigationHelper.types.DOWNLOAD_LINK)
  }

  const type = openSameTab
    ? NavigationHelper.types.PUSH
    : NavigationHelper.types.NEW_TAB
  navigationEvent(optionUrlPath, type)
}

const LinkDropdown = ({
  className,
  linkDropdownDisplayTitle = '',
  linkMenu,
  navigationEvent,
}) => {
  if (!linkMenu || linkMenu.length === 0) return null
  return (
    <StyledLinkDropdown
      className={className}
      defaultLabel={linkDropdownDisplayTitle}
      dropdownButtonIcon={<DownloadIcon />}
      keyProp="key"
      labelProp="label"
      onChange={link => LinkDropdownNavigation(link, navigationEvent)}
      options={linkMenu}
      shouldHideSelectedIcon={true}
    />
  )
}

LinkDropdown.propTypes = {
  className: PropTypes.string,
  linkDropdownDisplayTitle: PropTypes.string.isRequired,
  linkMenu: PropTypes.array.isRequired,
  navigationEvent: PropTypes.func.isRequired,
}

export default LinkDropdown
